var GEO_DATA, Geocoder, KeywordBar, Location, LocationBar, LocationError, SearchBarView, Typeahead, breakDownAddress, getGeoSearchOverrideUrl, getLocationForSearch, getLocationOverrideUrl, getSearchOverrideUrl, getSearchUrl, locationHasChanged, placeholderState, ref, removeGeolocationData, saveRecentSearch, setSiteCookies, storeGeolocationData, trackEvent, whichKeyAlias,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  slice = [].slice;

require('../../../../../../core/frontend/groupon_modules/groupon');

Geocoder = require('../../../../../../src/frontend/helper/search/common/m_geocoder');

Location = require('../../../../../../src/frontend/helper/search/helper/m_location_helper');

setSiteCookies = require('../../../../../../core/frontend/groupon_modules/setSiteCookies');

Groupon.setWindowLocation = require('../../../../../../core/frontend/groupon_modules/setWindowLocation');

KeywordBar = require('../../../../../../src/frontend/helper/search/view/m_keyword_bar');

LocationBar = require('../../../../../../src/frontend/helper/search/view/m_location_bar');

LocationError = require('../../../../../../src/frontend/helper/search/view/m_error');

Typeahead = require('../../../../../../src/frontend/helper/search/view/m_typeahead');

saveRecentSearch = require('../../../../../../src/frontend/helper/search/helper/m_typeahead_helper.coffee').saveRecentSearch;

whichKeyAlias = require('../../../../../../src/frontend/helper/search/common/m_keypress').whichKeyAlias;

placeholderState = require('../../../../../../src/frontend/helper/search/helper/m_common').placeholderState;

ref = require('../../../../../../src/frontend/helper/search/helper/m_searchbar_helper'), breakDownAddress = ref.breakDownAddress, getGeoSearchOverrideUrl = ref.getGeoSearchOverrideUrl, getLocationForSearch = ref.getLocationForSearch, getLocationOverrideUrl = ref.getLocationOverrideUrl, getSearchOverrideUrl = ref.getSearchOverrideUrl, getSearchUrl = ref.getSearchUrl, GEO_DATA = ref.GEO_DATA, removeGeolocationData = ref.removeGeolocationData, storeGeolocationData = ref.storeGeolocationData;

trackEvent = require('../../../../../../src/frontend/helper/general/m_trackEvent');

locationHasChanged = void 0;

module.exports = SearchBarView = (function() {
  var head, keyword, translations;

  head = document.head || document.getElementsByTagName('head')[0];

  keyword = translations = void 0;

  function SearchBarView(arg) {
    var $el, useLocationPlacesAPI;
    $el = arg.$el;
    this.redirectTo = bind(this.redirectTo, this);
    this.geocoderError = bind(this.geocoderError, this);
    this.geocoderSuccess = bind(this.geocoderSuccess, this);
    this.searchWithPlaces = bind(this.searchWithPlaces, this);
    this.searchWithAutocomplete = bind(this.searchWithAutocomplete, this);
    this.searchWithGmaps = bind(this.searchWithGmaps, this);
    this.searchWithGeolocation = bind(this.searchWithGeolocation, this);
    this._cleanGeolocationTraces = bind(this._cleanGeolocationTraces, this);
    this.unfreezeElements = bind(this.unfreezeElements, this);
    this.setSearchbarFocusTracking = bind(this.setSearchbarFocusTracking, this);
    this.onFormSubmit = bind(this.onFormSubmit, this);
    this.gatherData = bind(this.gatherData, this);
    this.getQuery = bind(this.getQuery, this);
    this.$form = $el;
    this.env = 'desktop';
    this.$body = $(document.body);
    this.$inputs = $el.find('#location, #search');
    this.$location = $el.find('#location');
    this.$search = $el.find('#search');
    this.$searchResultList = $('#ls-search-results');
    this.$mobileSubnav = $('.ls-mobile-subnav');
    this.$locationMobileSubnav = $('.ls-mobile-subnav-location');
    this.$primaryNavTabs = $('.primary-nav-tab');
    this.$overlay = $('#ls-resp-overlay');
    this.$submitButton = $('#ls-header-search-button');
    Groupon.LS.experiments['enableRecentLocations'] = false;
    if (typeof Finch !== "undefined" && Finch !== null) {
      Finch.experiment('LS-3153-RecentLocationsDesktop', {
        Control: function() {},
        RecentLocations: function() {
          return Groupon.LS.experiments['enableRecentLocations'] = true;
        }
      });
    }
    this.lang = I18n.lang, this.locale = I18n.locale, this.country = I18n.country;
    useLocationPlacesAPI = false;
    Finch.experiment('LS-3106-AddressAutocomplete', {
      Control: function() {},
      Treatment: function() {
        return useLocationPlacesAPI = true;
      }
    });
    this.useLocationPlacesAPI = useLocationPlacesAPI;
    this.render();
    this.bind();
    translations = Groupon.LS.translations;
    this.geolocationData = Location.getGeolocationData();
  }

  SearchBarView.prototype.bind = function() {
    this.$form.on('submit', (function(_this) {
      return function(e, state) {
        e.state = state;
        return _this.onFormSubmit(e);
      };
    })(this));

    /*
     * Input events
     */
    this.$inputs.on({
      'input focusin': (function(_this) {
        return function(e) {
          var el;
          el = e.currentTarget;
          placeholderState.toggle($(el));
          return _this.typeahead.buildAutocompleteList(e, el.name);
        };
      })(this),
      keydown: (function(_this) {
        return function(e) {
          var $match;
          switch (whichKeyAlias(e)) {
            case 'Enter':
              if (e.currentTarget.name === 'location') {
                e.preventDefault();
                if (($match = _this.typeahead.$container.find('.typeahead-match-highlight')).length) {
                  $match.trigger('click');
                } else {
                  _this.typeahead.hide();
                  _this.$form.trigger('submit', 'manual');
                }
              }
              break;
            case 'Tab':
              _this.typeahead.hide();
              break;
            case 'ArrowDown':
              _this.$searchResultList.find('a').eq(0).focus();
              _this.$searchResultList.find('.typeahead-match').removeClass('typeahead-match-highlight');
              e.preventDefault();
          }
        };
      })(this),
      focusin: (function(_this) {
        return function(e) {
          var $parent;
          _this.$body.eventPause('pause');
          if (!($parent = $(e.currentTarget).parent()).hasClass('active-search')) {
            _this.$form.find('label, div').removeClass('active-search');
            return $parent.addClass('active-search');
          }
        };
      })(this),
      focusout: (function(_this) {
        return function(e) {
          var $locLabel, $searchLabel, $this;
          _this.$body.eventPause('active');
          $this = $(e.currentTarget);
          $this.parent().removeClass('active-search');
          placeholderState.toggle($this);
          if (!$('html.ui-v3').length) {
            $searchLabel = _this.$search.parent('label');
            $locLabel = _this.$location.parent('label');
            if (!$searchLabel.is('.active-search') && !$locLabel.is('.active-search')) {
              return $searchLabel.addClass('active-search');
            }
          }
        };
      })(this)
    });

    /*
     * Global events
     */
    this.$body.on('click', (function(_this) {
      return function() {
        return _this.typeahead.hide();
      };
    })(this));
    $(window).one('load', (function(_this) {
      return function() {
        return _this.$form.find('input').each(function() {
          return placeholderState.toggle($(this));
        });
      };
    })(this));

    /*
     * Typeahead events
     */
    this.$searchResultList.on('click', 'a', (function(_this) {
      return function(e) {
        if ($(e.currentTarget).hasClass('current-location')) {
          e.preventDefault();
          _this.$form.trigger('submit', 'geolocate');
        } else {
          _this.selectAndFill(e);
        }
      };
    })(this));
    return this.$searchResultList.on('keydown', 'a', (function(_this) {
      return function(e) {
        var $el, $results, $widget;
        e.preventDefault();
        $widget = _this.$searchResultList;
        $results = $widget.find('a');
        switch (whichKeyAlias(e)) {
          case 'Enter':
            $el = $(e.currentTarget);
            if ($el.hasClass('current-location')) {
              return $el.trigger('click');
            } else {
              return _this.selectAndFill(e);
            }
            break;
          case 'ArrowUp':
            return $results.eq($results.index(e.currentTarget) - 1).focus();
          case 'ArrowDown':
            return $results.eq($results.index(e.currentTarget) + 1).focus();
          default:
            if (whichKeyAlias(e) === 'Tab' && $widget.is('typeahead-search')) {
              return _this.selectAndTab(e);
            } else {
              return _this.$searchResultList.prev('input').focus();
            }
        }
      };
    })(this));
  };


  /**
   * Write deal data to deal input from autocomplete item
   *
   * @param {Object} $trigger - jQuery object of autocomplete item
   */

  SearchBarView.prototype.updateValue = function($trigger) {
    placeholderState.set(this.$search, 'hide');
    this.$search.val($trigger.data('value'));
  };


  /**
   * Set location data to location input from autocomplete item
   *
   * @param {Object} $trigger - jQuery object of autocomplete item
   */

  SearchBarView.prototype.updateValueAndLatLng = function($trigger) {
    var data, division, lat, lng, place_id, ref1, value;
    ref1 = $trigger.data(), value = ref1.value, lat = ref1.lat, lng = ref1.lng, division = ref1.division, place_id = ref1.place_id;
    data = this.useLocationPlacesAPI ? {
      place_id: place_id,
      'manual': false
    } : {
      lat: lat.toString(),
      lng: lng.toString(),
      division: division,
      'manual': false
    };
    this.$location.val(value).data(data);
  };


  /**
   * Autocomplete link handler
   * Updates deal or location input
   *
   * @param {Object} e - jQuery event
   */

  SearchBarView.prototype.selectAndFill = function(e) {
    var $trigger, $widget, matchClass, state;
    $trigger = $(e.currentTarget);
    $widget = this.$searchResultList;
    if (!$trigger.hasClass(matchClass = 'typeahead-match')) {
      $widget.find('.typeahead-match').removeClass(matchClass);
    }
    if ($widget.hasClass('typeahead-location')) {
      state = 'autocomplete';
      this.updateValueAndLatLng($trigger);
    } else {
      state = void 0;
      this.updateValue($trigger);
    }
    this.$form.trigger('submit', state);
  };

  SearchBarView.prototype.selectAndTab = function(e) {
    this.updateValueAndLatLng($(e.currentTarget));
    this.$searchResultList.hide();
    this.$location.focus();
  };

  SearchBarView.prototype.render = function() {
    var enableBetterUx, enableGeoLocation, enableRecentLocations, enableRecentSearches, experiments, flags, options, ref1, ref2, ref3;
    ref1 = Groupon.LS, options = ref1.options, experiments = ref1.experiments, flags = ref1.flags;
    if (options == null) {
      options = {};
    }
    options = _.assign({}, options, experiments, flags);
    if (options != null) {
      enableGeoLocation = options['enableGeoLocation'];
      enableBetterUx = options['enableLocationImprovements'];
      enableRecentLocations = options['enableRecentLocations'];
      enableRecentSearches = true;
    }
    this.typeahead = new Typeahead({
      env: this.env,
      resultList: this.$searchResultList,
      endpoints: {
        search: (ref2 = Groupon.endpoints) != null ? ref2.deals : void 0,
        location: (ref3 = Groupon.endpoints) != null ? ref3.locations : void 0
      },
      enableGeoLocation: enableGeoLocation,
      enableRecentSearches: enableRecentSearches,
      enableRecentLocations: enableRecentLocations,
      enableBetterUx: enableBetterUx,
      fetchWithPlacesApi: this.useLocationPlacesAPI,
      experiments: experiments
    });
    this.locationError = new LocationError({
      $el: this.$form,
      $resultList: this.$searchResultList,
      env: this.env,
      enableBetterUx: enableBetterUx
    });
    this.keywordBar = new KeywordBar({
      el: this.$form,
      env: this.env
    });
    this.locationBar = new LocationBar({
      el: this.$form,
      env: this.env
    });
    return this.setSearchbarFocusTracking();
  };

  SearchBarView.prototype.getQuery = function() {
    var maxChars, ref1, ref2;
    maxChars = this.$search.attr('maxlength') || 50;
    keyword = (ref1 = this.keywordBar) != null ? (ref2 = ref1.val()) != null ? ref2.trim().slice(0, maxChars) : void 0 : void 0;
    if (!_.isBlank(keyword)) {
      return keyword;
    }
  };

  SearchBarView.prototype.gatherData = function(state) {
    var data, dealSearch, geoMaximumAge, geolocationData, locData, locSearch, locationMatch, ref1, ref2, ref3;
    geolocationData = (ref1 = this.geolocationData) != null ? ref1.current_location : void 0;
    dealSearch = this.getQuery();
    locSearch = this.locationBar.val();
    if (!((dealSearch != null) || (locSearch != null))) {
      return;
    }
    if (dealSearch != null) {
      saveRecentSearch(dealSearch, 'deal');
    }
    if ((locationMatch = $('.typeahead-location .typeahead-match')).length) {
      data = _.pick(locationMatch.data(), 'lat', 'lng');
    } else {
      locData = this.$location.data();
      if (locData.manual && state === void 0) {
        state = 'manual';
      }
      switch (state) {
        case 'autocomplete':
        case 'manual':
          data = _.pick(locData, 'lat', 'lng', 'closestDivision', 'place_id');
          break;
        default:
          data = _.pick.apply(_, [locData, 'lat', 'lng', 'closestDivision'].concat(slice.call(GEO_DATA)));
          geoMaximumAge = (ref2 = Groupon.Modules.SearchBar.geolocationOptions) != null ? ref2.maximumAge : void 0;
          if (geoMaximumAge && Date.now() - (geolocationData != null ? geolocationData.timeStamp : void 0) > geoMaximumAge) {
            state = 'geolocate';
          }
      }
    }
    if (!geolocationData || !data.closestDivision) {
      data.closestDivision = (ref3 = Groupon.division) != null ? ref3.id : void 0;
    }
    return {
      data: _.extend(data, {
        address: locSearch,
        query: keyword
      }),
      state: state
    };
  };

  SearchBarView.prototype.lockSubmit = function(lock) {
    if (lock == null) {
      lock = false;
    }
    if (lock) {
      this.$submitButton.attr('disabled', true).removeClass('icon-magnifying-glass').addClass('ls-loading-white');
    } else {
      this.$submitButton.attr('disabled', false).removeClass('ls-loading-white').addClass('icon-magnifying-glass');
    }
  };

  SearchBarView.prototype.onFormSubmit = function(e) {
    var data, fn, overrideUrl, ref1, state;
    e.preventDefault();
    state = e.state;
    ref1 = this.gatherData(state), data = ref1.data, state = ref1.state;
    if (data == null) {
      return;
    }
    this.lockSubmit(true);
    this.$location.eventPause('pause').addClass('search-hide-selection');
    this.$primaryNavTabs.eventPause('pause');
    overrideUrl = getGeoSearchOverrideUrl(data.query, data.address);
    if (overrideUrl != null) {
      return Groupon.setWindowLocation(overrideUrl);
    }
    locationHasChanged = true;
    switch (state) {
      case 'geolocate':
        data.currentLocation = true;
        locationHasChanged = false;
        fn = this.searchWithGeolocation;
        break;
      case 'autocomplete':
        fn = this.searchWithAutocomplete;
        Location.removeGeolocationData('current_location');
        if (this.useLocationPlacesAPI && data.place_id) {
          fn = this.searchWithPlaces;
        }
        break;
      case 'manual':
        fn = this.searchWithGmaps;
        Location.removeGeolocationData('current_location');
        break;
      default:
        locationHasChanged = false;
        fn = this.redirectTo;
    }
    return fn(data);
  };

  SearchBarView.prototype.setSearchbarFocusTracking = function() {
    return this.$form.on('focusin.searchbar', (function(_this) {
      return function(e) {
        if (e.target && $(e.currentTarget).find(e.target).length) {
          trackEvent('searchbar-focusin');
          _this.$form.off('focusin.searchbar');
          return _this.$form.on('focusout.searchbar', function(e) {
            if (!$(e.currentTarget).find(e.relatedTarget).length) {
              trackEvent('searchbar-focusout');
              _this.$form.off('focusout.searchbar');
              return _this.setSearchbarFocusTracking();
            }
          });
        }
      };
    })(this));
  };

  SearchBarView.prototype.unfreezeElements = function() {
    this.$location.eventPause('active');
    return this.$primaryNavTabs.eventPause('active');
  };

  SearchBarView.prototype._cleanGeolocationTraces = function() {
    var data, lat, lng, name, options;
    Location.removeGeolocationData('current_location');
    Location.setGeolocationData('geoLocationGranted', false);
    if (translations.search.currentlocation === this.$location.val() && ((data = Groupon.division) != null)) {
      lat = data.lat, lng = data.lng, name = data.name;
      options = {
        address: name,
        lat: lat,
        lng: lng,
        geocoderSuccess: (function(_this) {
          return function(arg) {
            var locationData;
            locationData = arg.locationData;
            _this.$location.data(locationData).val(locationData.friendlyName);
            return Location.setSearchLocCookie(locationData);
          };
        })(this),
        geocoderError: function() {}
      };
      return this.searchWithGmaps(options);
    }
  };

  SearchBarView.prototype.searchWithGeolocation = function(data) {
    var geoLocationError, geolocationSuccess, query;
    if (data == null) {
      query = this.getQuery();
      data = {
        address: translations.search.nearme,
        query: query
      };
    }
    $('.typeahead-response.location').hide();
    geolocationSuccess = (function(_this) {
      return function(arg) {
        var lat, lng;
        lat = arg.lat, lng = arg.lng;
        _this.$location.val(data.address);
        data = _.extend(data, {
          lat: lat,
          lng: lng,
          current_location: true
        });
        trackEvent('location-bar-geolocation-success', {
          lat: lat,
          lng: lng
        });
        Location.setGeolocationData('geoLocationGranted', true);
        return _this.searchWithAutocomplete(data);
      };
    })(this);
    geoLocationError = (function(_this) {
      return function(err) {
        _this._cleanGeolocationTraces();
        trackEvent('location-bar-geolocation-error', err);
        _this.locationError.displayAvailabilityError('current-location');
        _this.unfreezeElements();
        return _this.lockSubmit(false);
      };
    })(this);
    return Groupon.Utils.detectCurrentLocation(geolocationSuccess, geoLocationError);
  };

  SearchBarView.prototype.searchWithGmaps = function(options) {
    var address, current_location, geocoderError, geocoderSuccess, lat, lng;
    if (options == null) {
      options = {};
    }
    address = options.address, current_location = options.current_location, lat = options.lat, lng = options.lng, geocoderSuccess = options.geocoderSuccess, geocoderError = options.geocoderError;
    options = {
      address: address,
      location: {
        lat: lat,
        lng: lng
      },
      current_location: current_location,
      country: this.country,
      geocoderSuccess: geocoderSuccess,
      geocoderError: geocoderError
    };
    if (!(geocoderSuccess || geocoderError)) {
      options = _.extend({}, options, {
        geocoderSuccess: this.geocoderSuccess,
        geocoderError: this.geocoderError
      });
    }
    if (!this.geocoder) {
      this.geocoder = new Geocoder();
    }
    return this.geocoder.geocode(options);
  };

  SearchBarView.prototype.searchWithAutocomplete = function(data) {
    var address, query;
    address = data.address, query = data.query;
    trackEvent('location-bar-autocomplete-successful-match', {
      query: query,
      address: address
    });
    if (this.country === 'US') {
      data = breakDownAddress(data);
    }
    data = _.extend({}, data, {
      geocoderSuccess: this.geocoderSuccess,
      geocoderError: this.geocoderError
    });
    return new Geocoder().fetchClosestDivision(data);
  };


  /*
   * LS-3106 search with Places API proxy and getClosestDivision
   *
   */

  SearchBarView.prototype.searchWithPlaces = function(data) {
    var address, ajaxConfig, error, place_id, query;
    address = data.address, query = data.query, place_id = data.place_id;
    trackEvent('location-bar-places-successful-match', data);
    error = (function(_this) {
      return function(err) {
        return _this.geocoderError({
          address: address,
          status: 'UNAVAILABLE',
          data: err
        });
      };
    })(this);
    ajaxConfig = {
      url: '/layout/calls/service',
      data: {
        place_id: place_id,
        service: 'location-details',
        I18n: {
          locale: this.locale,
          country: this.country
        }
      },
      success: (function(_this) {
        return function(arg) {
          var data, err;
          data = arg.data, err = arg.err;
          if (err) {
            return error(err);
          }
          return _this.geocoderSuccess({
            query: query,
            address: address,
            locationData: _.extend(data, {
              locationId: place_id
            }),
            current_location: false
          });
        };
      })(this),
      error: error
    };
    $.ajax(ajaxConfig);
  };

  SearchBarView.prototype.geocoderSuccess = function(arg) {
    var address, currentLocationData, current_location, data, hasLocCookie, locationData, query, trackyEventName;
    address = arg.address, query = arg.query, locationData = arg.locationData, current_location = arg.current_location;
    Location.setELLCookie(locationData.lat + ',' + locationData.lng);
    if (query == null) {
      query = keyword;
    }
    if (locationData.fullAddress != null) {
      address = locationData.fullAddress;
    }
    trackyEventName = 'location-bar-geocode-search-success';
    if (current_location) {
      address = translations.search.nearme;
      trackyEventName = 'location-bar-geolocation-search-success';
      currentLocationData = _.pick(data, 'lat', 'lng', 'closestDivision', 'division', 'address');
      currentLocationData = Object.assign(currentLocationData, {
        timeStamp: new Date().getTime()
      });
      storeGeolocationData(current_location, currentLocationData);
    } else {
      removeGeolocationData();
    }
    locationData.address = locationData.friendlyName = address;
    Location.setSearchLocCookie(locationData);
    hasLocCookie = true;
    trackEvent(trackyEventName, {
      address: address,
      locationData: locationData,
      query: query
    });
    if ((data = locationData || getLocationForSearch())) {
      data = _.omit(data, ['fullAddress', 'friendlyName', 'types']);
      data = _.extend(data, {
        query: query
      });
      return this.redirectTo(data, hasLocCookie);
    }
  };

  SearchBarView.prototype.geocoderError = function(arg) {
    var address, data, status;
    address = arg.address, status = arg.status, data = arg.data;
    this.unfreezeElements();
    this.lockSubmit(false);
    if (status === 'ABORT') {
      return;
    }
    if (status === 'BAD_LOCATION') {
      this.locationError.displayBadLocationError(address);
    } else if (status === 'UNAVAILABLE') {
      this.locationError.displayAvailabilityError(address);
    }
    return trackEvent('location-bar-geocode-search-error', {
      address: address,
      data: data
    });
  };

  SearchBarView.prototype.redirectTo = function(data, hasLocCookie) {
    var address, closestDivision, division, locData, newUrl, query, searchEvent;
    closestDivision = data.closestDivision, division = data.division;
    if (!((closestDivision != null) || (division != null))) {
      this.lockSubmit(false);
      return;
    }
    if (closestDivision && !division) {
      division = closestDivision;
    }
    setSiteCookies({
      division: division
    });
    if (locationHasChanged && Groupon.LS.experiments['enableRecentLocations']) {
      locData = _.pick(data, 'lat', 'lng', 'address');
      locData.division = data.closestDivision;
      saveRecentSearch(locData, 'location');
    }
    address = data.address, query = data.query;
    searchEvent = query ? hasLocCookie ? 'deal-search-with-loc-cookie' : 'deal-search-with-no-loc-cookie' : 'location-search';
    trackEvent(searchEvent, {
      address: address,
      query: query
    });
    newUrl = getLocationOverrideUrl(data) || getSearchOverrideUrl(division, data, false) || getSearchUrl(division, _.omit(data, 'closestDivision'));
    Groupon.setWindowLocation(newUrl);
  };

  return SearchBarView;

})();

